import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import GlobalStyle from './style/global';
import styled from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { LangProvider } from "Translation/index";
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

ReactDOM.render(
  <Wrapper>
    <GlobalStyle />
    <LangProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LangProvider>
    
  
  </Wrapper>,
  document.getElementById('root'),
);
